import React from 'react';
export function SolutionSection() {
  const tomos = [{
    color: '#1A237E',
    label: 'A1'
  }, {
    color: '#1B5E20',
    label: 'A2'
  }, {
    color: '#BF360C',
    label: 'B1'
  }, {
    color: '#4A148C',
    label: 'B2'
  }, {
    color: '#263238',
    label: 'C1/C2'
  }, {
    color: '#BF360C',
    label: 'Kit Eval.'
  }];
  return <section className="w-full bg-black py-16 px-4" data-id="element-407">
      <div className="max-w-4xl mx-auto text-center" data-id="element-408">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00E68A]/50 text-[#00E68A] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-409">
          🏆 Sistema N°1 para Docentes de Lengua y Literatura Secundaria en
          Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-410">
          🌟 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#00E68A] mb-2" data-id="element-411">
          MEGAPACK LENGUA Y LITERATURA SECUNDARIA
        </h3>
        <p className="text-xl text-white font-bold mb-4" data-id="element-412">
          6 Tomos + 6 Bonos — 1° a 6° Año — Todo resuelto.
        </p>
        <p className="text-gray-300 text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-413">
          360+ páginas de contenido curricular completo. Solucionario en cada
          tomo. Planificación anual lista para presentar. Listo para usar desde
          hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-12 max-w-2xl" data-id="element-414">
          <div className="grid grid-cols-6 gap-2 sm:gap-3 justify-center" data-id="element-415">
            {tomos.map((tomo, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-3" style={{
            backgroundColor: tomo.color,
            border: '2px solid rgba(0,230,138,0.3)'
          }} data-id="element-416">
                <span className="text-white text-[10px] sm:text-xs font-bold" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-417">
                  {tomo.label}
                </span>
              </div>)}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00E68A] text-gray-900 font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-418">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-419">
          <span className="bg-transparent border border-[#00E68A]/50 text-[#00E68A] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-420">
            ✅ 1° a 6° con solucionario completo
          </span>
          <span className="bg-transparent border border-[#00E68A]/50 text-[#00E68A] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-421">
            ✅ Planificación anual lista
          </span>
          <span className="bg-transparent border border-[#00E68A]/50 text-[#00E68A] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-422">
            ✅ Evaluaciones y rúbricas
          </span>
          <span className="bg-transparent border border-[#00E68A]/50 text-[#00E68A] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-423">
            ✅ 6 bonos incluidos
          </span>
          <span className="bg-transparent border border-[#00E68A]/50 text-[#00E68A] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-424">
            ✅ Secuencias didácticas completas
          </span>
          <span className="bg-transparent border border-[#00E68A]/50 text-[#00E68A] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-425">
            ✅ 100% alineado a NAP y Diseños Curriculares
          </span>
        </div>
      </div>
    </section>;
}